// src/components/LoginPage.vue
<template>
<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-md-4">
            <h2 class="mb-4 text-center">Login</h2>

            <!-- Username input -->
            <div class="mb-3">
                <input type="text" v-model="username" placeholder="Username" class="form-control" required />
            </div>

            <!-- Password input -->
            <div class="mb-3">
                <input type="password" v-model="password" placeholder="Password" class="form-control" required />
            </div>

            <!-- Login button -->
            <div class="d-grid">
                <button @click="loginAndGetOAuthToken" class="btn btn-primary">
                    Login
                </button>
            </div>

            <!-- Error message -->
            <p v-if="error" class="text-danger mt-3">{{ error }}</p>
        </div>
    </div>
</div>
</template>

<script>
import {
    CARE_MW_API_BASE_URL
} from "@/apiConfig";
import {
    clearLocalStorageLists
} from "@/localCache";
import axios from "axios";
export default {
    data() {
        return {
            username: "",
            password: "",
            error: null,
        };
    },
    methods: {
        async loginAndGetOAuthToken() {
            try {
                const response = await axios.post(
                    CARE_MW_API_BASE_URL + "/login", {
                        uid: this.username, // Add first parameter
                        pwd: this.password, // Add second parameter
                    }, {
                        headers: {
                            "ngrok-skip-browser-warning": "true", // Add this header to bypass the warning
                        },
                        cache: false, // Disable cache for this request
                    }
                );

                // Assuming the response contains the access token
                console.log(response.data);
                localStorage.setItem("token", response.data.access_token);
                localStorage.setItem("token2", response.data.auth_token);
                localStorage.setItem("username", this.username);
                //console.log("Access Token:", response);
                this.error = null;
                clearLocalStorageLists();
                await this.$router.push("/home"); // once complete reload the page for the localstorage value and islogged in to work properly
                window.location.reload();
            } catch (error) {
                console.log(error);
                if (error.response.status == 401) {
                    this.error = "Auth Failed. UserID and/or password wrong!";
                }
            }
        },
    },
};
</script>
